import { CRMTitle } from '@marketplace/mysale-connect/model_pb';

export const isStaff = (titles : CRMTitle[]) => {
    if (titles?.length === 1) {
        return titles[0] === CRMTitle.CRM_TITLE_STAFF
    }
    return false;
};

export const isManager = (titles : CRMTitle[]) => {
    return titles.some((title) => title === CRMTitle.CRM_TITLE_MANAGER);
};

export const isHelpdesk = (titles : CRMTitle[]) => {
    return titles.some((title) => title === CRMTitle.CRM_TITLE_HELPDESK);
};

export const isLeader = (titles : CRMTitle[]) => {
    return titles.some((title) => title === CRMTitle.CRM_TITLE_LEADER);
};

export const getTitle = (titles : CRMTitle[]) : CRMTitle => {
    if (isStaff(titles)) {
        return CRMTitle.CRM_TITLE_STAFF;
    }
    if (isHelpdesk(titles)) {
        return CRMTitle.CRM_TITLE_HELPDESK;
    }
    if (isManager(titles)) {
        return CRMTitle.CRM_TITLE_MANAGER;
    }
    if (isLeader(titles)) {
        return CRMTitle.CRM_TITLE_LEADER;
    }
    return CRMTitle.CRM_TITLE_STAFF;
};
